// extracted by mini-css-extract-plugin
export default {"inputWrapper":"CreateNewViewModal_inputWrapper__bItcZ"};